import { Button, Link } from '@chakra-ui/react';
import React from 'react';
import { useNavLink } from '../hooks/use-nav-link';

/**
 * Link to an External System, will link out of this application
 */
function ExternalRegionLinkRefFunction(
    {
        path,
        children,
        ...linkProps
    }: Omit<React.ComponentPropsWithoutRef<typeof Link>, 'href'> & { path?: string },
    ref: React.ForwardedRef<HTMLAnchorElement>
) {
    const transformedHref = useNavLink({
        to: path,
        isExternal: true,
    });

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Link
            ref={ref}
            href={transformedHref}
            _hover={{ textDecoration: 'none' }}
            {...linkProps}
        >
            {children}
        </Link>
    );
}

function ExternalRegionButtonRefFunction(
    {
        path,
        children,
        ...linkProps
    }: Omit<React.ComponentPropsWithoutRef<typeof Link>, 'href'> & { path?: string },
    ref: React.ForwardedRef<HTMLAnchorElement>
) {
    const transformedHref = useNavLink({
        to: path,
        isExternal: true,
    });

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Button
            {...linkProps}
        >
            <Link
                ref={ref}
                href={transformedHref}
                textDecoration="none"
                _hover={{ textDecoration: 'none' }}
            >
                {children}
            </Link>
        </Button>
    );
}

export const ExternalRegionLink = React.forwardRef(ExternalRegionLinkRefFunction);
export const ExternalRegionLinkButton = React.forwardRef(ExternalRegionButtonRefFunction);
